import {
  emailRegex,
  nameRegex,
  tenDigitMobileRegex,
} from "DataMapper/Common/RegexConstants"
import { ReactNode } from "react"

export const ieltsEliteFormRequiredFields = [
  "ieltsExamType",
  "whatCareerStage",
  "whenIelts",
  "name",
  "emailId",
  "phone",
]
export const ieltsEliteJsonV2: any = {
  form_id: "Ielts Demo Form",
  form_meta: {
    title: "",
    image: "",
  },
  no_of_steps: 4,
  page_distribution: [1, 1, 1, 3],
  is_auto_progressive: true,
  required: ieltsEliteFormRequiredFields,
  fields: [
    {
      question_id: 1,
      label: "Ielts Type",
      type: "single_select_tile",
      fieldValue: "ieltsExamType",
      question_text: "What's your IELTS type?",
      options: [
        {
          label: "IELTS General",
          value: "GENERAL",
          color: "#3BAC76",
          icon: true,
        },
        {
          label: "IELTS Academic",
          value: "ACADEMIC",
          color: "#443EFF",
          icon: true,
        },
        {
          label: "Not Sure",
          value: "OTHER",
          color: "#FF9C40",
          icon: true,
        },
      ],
      default_visibility: true,
      validation: { pattern: "", errorMessage: "" },
    },
    {
      question_id: 2,
      label: "Ielts Type",
      type: "single_select_tile",
      fieldValue: "whatCareerStage",
      question_text: "What are you currently doing?",
      options: [
        {
          label: "Studying",
          value: "STUDENT",
          color: "#3BAC76",
          icon: true,
        },
        {
          label: "Working",
          value: "WORKING",
          color: "#56AADE",
          icon: true,
        },
        {
          label: "Recently graduated",
          value: "RECENTLY_GRADUATED",
          color: "#443EFF",
          icon: true,
        },
      ],
      default_visibility: true,
      validation: { pattern: "", errorMessage: "" },
    },
    {
      question_id: 3,
      label: "Ielts Type",
      type: "single_select_tile",
      fieldValue: "whenIelts",
      question_text: "When are you giving IELTS?",
      options: [
        {
          label: "Within 3 months",
          value: "WITHIN_3_MONTHS",
          icon: true,
        },
        {
          label: "Within 3 - 6 months",
          value: "WITHIN_3_6_MONTHS",
          icon: true,
        },
        {
          label: "After 6 months",
          value: "AFTER_6_MONTHS",
          icon: true,
        },
        {
          label: "I've already booked exam",
          value: "BOOKED_EXAM",
          icon: true,
        },
      ],
      default_visibility: true,
      validation: { pattern: "", errorMessage: "" },
    },
    {
      question_id: 4,
      label: "Name*",
      type: "textInput",
      fieldValue: "name",
      options: [],
      default_visibility: true,
      visibility_dependency: {
        dependencies: [
          {
            question_id: 0,
            value: [],
          },
        ],
      },
      validation: {
        pattern: nameRegex,
        errorMessage: "Enter correct name",
      },
    },
    {
      question_id: 5,
      label: "Email Address*",
      type: "textInput",
      fieldValue: "emailId",
      options: [],
      default_visibility: true,
      visibility_dependency: {
        dependencies: [
          {
            question_id: 0,
            value: [],
          },
        ],
      },
      validation: {
        pattern: emailRegex,
        errorMessage: "Please enter correct email",
      },
    },
    {
      question_id: 6,
      label: "Phone Number*",
      type: "textInput",
      fieldValue: "phone",
      options: [],
      default_visibility: true,
      visibility_dependency: {
        dependencies: [
          {
            question_id: 0,
            value: [],
          },
        ],
      },
      validation: {
        pattern: tenDigitMobileRegex,
        errorMessage: "please enter correct number",
      },
    },
  ],
}

export const getBaselineText = (currentStep: number): string | ReactNode => {
  if (currentStep === 1) return "Get a customized 8-band preparation strategy"
  else if (currentStep === 2)
    return "Clear your doubts from experienced trainers"
  else if (currentStep === 3) return "Get bonus tips on speaking & writing"
  else if (currentStep === 4) return "Fulfil your dream of succeeding abroad"
  else return "Get a customized 8-band preparation strategy"
}
